import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mic, ArrowRight } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import useReducedMotion from '../../hooks/useReducedMotion';
import { fadeUp, maybe, cardHover } from '../../lib/motionVariants';

/**
 * InterviewPromoCard — dark navy promo card pointing at the AI interview
 * simulation feature ("Mülakat Simülasyonu" — Panel redesign).
 *
 * Only rendered when the student has real access to the feature (see
 * Dashboard.js — gated on cabin-crew course enrollment, no new endpoint).
 */
export default function InterviewPromoCard() {
  const { t } = useLanguage();
  const reduced = useReducedMotion();

  return (
    <motion.div
      variants={maybe(reduced, fadeUp)}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        variants={maybe(reduced, cardHover)}
        initial="rest"
        whileHover="hover"
        whileTap="tap"
      >
        <Link
          to="/programs/kabin-memurlugu/interview"
          className="relative block overflow-hidden rounded-2xl p-5 text-[#F7F5F0]"
          style={{ background: 'linear-gradient(135deg,#0E1F3D,#1c3560)' }}
          data-testid="interview-promo-card"
        >
          <Mic
            size={90}
            strokeWidth={1.5}
            className="absolute -top-5 -right-2 opacity-[0.12] pointer-events-none"
            aria-hidden="true"
          />
          <div className="text-[11px] font-bold uppercase tracking-wider text-[#C9A227] mb-1">
            {t('dashboard.duo.interviewPromo.badge')}
          </div>
          <div className="font-duo-display text-lg mb-1.5">
            {t('dashboard.duo.interviewPromo.title')}
          </div>
          <p className="text-[13px] leading-relaxed text-[#cdd6e3] mb-3.5 max-w-[24ch]">
            {t('dashboard.duo.interviewPromo.desc')}
          </p>
          <span className="inline-flex items-center gap-2 bg-[#34CC67] text-[#08331d] text-sm font-bold px-4 py-2.5 rounded-[10px]">
            {t('dashboard.duo.interviewPromo.cta')}
            <ArrowRight size={15} strokeWidth={2.5} aria-hidden="true" />
          </span>
        </Link>
      </motion.div>
    </motion.div>
  );
}
